export default __webpack_public_path__ + "static/media/ITR-55.38d4b4ae.png";